/**
 * Default workspace settings
 * These are used as fallback when cloud settings are unavailable
 * Can be overridden by environment variables at build time
 */

import type { WorkspaceSettings } from '../core/models/Workspace'

export const DEFAULT_WORKSPACE_SETTINGS: WorkspaceSettings = {
  id: 'default',
  name: process.env.VITE_WORKSPACE_NAME || 'Sevv',
  platform_name: process.env.VITE_PLATFORM_NAME || 'Sevv',
  platform_url: process.env.VITE_PLATFORM_URL || 'https://app.sevv.com',
  logo_url: process.env.VITE_LOGO_URL || '/logo192.png',
  allowed_domains: process.env.VITE_ALLOWED_DOMAINS?.split(',') || [],
  registration_enabled: process.env.VITE_REGISTRATION_ENABLED !== 'false',
  urls: {
    primaryColor: process.env.VITE_PRIMARY_COLOR || '#389acb',
    secondaryColor: process.env.VITE_SECONDARY_COLOR || '#2c3e50',
    accentColor: process.env.VITE_ACCENT_COLOR || '#e74c3c',
    textColor: process.env.VITE_TEXT_COLOR || '#424242',
    backgroundColor: process.env.VITE_BACKGROUND_COLOR || '#fafafa',
  },
  features: {
    mapEditor: process.env.VITE_FEATURE_MAP_EDITOR !== 'false',
    chat: process.env.VITE_FEATURE_CHAT !== 'false',
    whiteboard: process.env.VITE_FEATURE_WHITEBOARD !== 'false',
  },
  restrictions: {
    maxRoomsPerUser: parseInt(process.env.VITE_MAX_ROOMS_PER_USER || '10'),
    maxUsersPerRoom: parseInt(process.env.VITE_MAX_USERS_PER_ROOM || '50'),
  },
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
} 